import { ENV } from '../../config/env';

export const getIsUSCommunity = (communityId) => {
  const US_COMMUNITY = ENV === 'production' ? 6 : 7;

  return communityId === US_COMMUNITY;
};
